<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                @if(outlook_connected && outlook_mail){
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/calendar-page-icon.svg" alt="Calendariov" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Calendario</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{getDropdownText()}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'dia'" (click)="selectItem('dia')">
                                        <span class="check-icon" *ngIf="selectedItem === 'dia'">✔</span>
                                        Ver por día
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'semana'" (click)="selectItem('semana')">
                                        <span class="check-icon" *ngIf="selectedItem === 'semana'">✔</span>
                                        Ver por semana
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'mes'" (click)="selectItem('mes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'mes'">✔</span>
                                        Ver por mes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline">
                            <img src="assets/svg/task-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Nuevo evento
                        </button>
                        <button class="action-btn outline">
                            Hoy
                        </button>
                        <button class="btn btn-round-outline"><img src="assets/svg/reload-icon-org.svg" alt=""></button>
                        <button class="btn btn-round-org"><img src="assets/svg/arrow-right.svg" alt=""></button>
                    </div>
                </div>
                <div class="content-area">
                    <div class="calendar-content">
                        <full-calendar #calendar [options]="calendarOptions()"></full-calendar>
                    </div>
                </div>
            }@else{
                <div class="no-outlook-connection">
                    <h5 class="text-center mt-3">No hay una cuenta de Outlook conectada</h5>
                    <p class="text-center color-gray">Para ver el calendario, es necesario conectar una cuenta de Outlook.</p>
                    <div class="d-flex flex-row justify-center mt-4">
                        <button class="btn btn-primary" (click)="connectOutlook()">Conectar cuenta de Outlook</button>
                    </div>
                </div>
            }
            </div>
        </div>
    </div>
</div>
